import React from "react";
import styled from "styled-components";
import { COLOR_SYSTEM } from "components/design/design-system";

interface Tab {
  id: string;
  label: string;
}

interface TabsProps {
  tabs: Tab[];
  activeTab: string;
  onTabChange: (tabId: string) => void;
}

const TabsContainer = styled.div`
  display: flex;
  border-bottom: 1px solid ${COLOR_SYSTEM.get("Gray")?.[100]};
`;

const TabItem = styled.div<{ isActive: boolean }>`
  padding: 12px 16px;
  cursor: pointer;
  font-size: 14px;
  font-weight: ${({ isActive }) => (isActive ? "bold" : "normal")};
  color: ${({ isActive }) =>
    isActive ? COLOR_SYSTEM.get("Blue")?.[600] : COLOR_SYSTEM.get("Gray")?.[700]};
  border-bottom: 2px solid
    ${({ isActive }) => (isActive ? COLOR_SYSTEM.get("Blue")?.[600] : "transparent")};
  margin-right: 8px;
  transition: all 0.2s ease;

  &:hover {
    color: ${({ isActive }) =>
      isActive ? COLOR_SYSTEM.get("Blue")?.[600] : COLOR_SYSTEM.get("Gray")?.[900]};
  }
`;

const Tabs: React.FC<TabsProps> = ({ tabs, activeTab, onTabChange }) => {
  return (
    <TabsContainer>
      {tabs.map((tab) => (
        <TabItem key={tab.id} isActive={activeTab === tab.id} onClick={() => onTabChange(tab.id)}>
          {tab.label}
        </TabItem>
      ))}
    </TabsContainer>
  );
};

export default Tabs;
